export default function initialState(questions) {
	return questions.reduce((acc, question) => {
		let initialValue;
		switch (question.type) {
			case "CheckboxMultiple":
				initialValue = [];
				break;
			case "Checkbox":
				initialValue = false;
				break;
			case "Parent":
				initialValue = [initialState(question.children)];
				break;
			case "KeyboardTimePicker":
				initialValue = "11:45";
				break;
			case "NumberFormat":
				initialValue = 0;
				break;
			default:
				initialValue = "";
				break;
		}
		return { ...acc, [question.id]: initialValue };
	}, {});
}
